<template>
    <CModal title="Chọn sản phẩm" :show.sync="isShowPopup">
        <template>
            <div>
                <CRow class="mb-3 search-panel"> 
                    <CCol sm="12" xs="12" md="12" lg="12" xl="12">
                        <BaseInput
                        :options="codeInput.options"
                        :data="codeInput.data"
                        :listener="codeInput.listener"
                        />
                    </CCol>
                    <CCol sm="12" xs="12" md="12" lg="12" xl="12">
                        <BaseInput
                        :options="nameInput.options"
                        :data="nameInput.data"
                        :listener="nameInput.listener"
                        />
                    </CCol>
                    <CCol>
                        <CButton
                        style="float: right;margin-left: 5px; margin-top: 10px"
                        color="primary"
                        v-c-tooltip.hover="'Tìm kiếm'"
                        class="btn-action-primary"
                        @click="loadDataMainTable(true)">
                        <i class="fa fa-search"></i>&nbsp;&nbsp; Tìm kiếm
                        </CButton>
                    </CCol>
                </CRow>
                <CCard class="content-fade-in mt-3p5">
                <CCardBody>
                    <BaseTable
                    :options="mainTable.options"
                    :slots="mainTable.slots"
                    :dataSource="mainTable.dataSource"
                    ref="mainTable"
                    >
                    <template #checkbox="{item}">
                        <td class="group-checkbox">
                        <div class="custom-control custom-checkbox">
                            <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="actionData.model.listProductSelected"
                            :value="item.id"
                            :id="item.id"
                            v-c-tooltip.hover="'Selected'"
                            />
                            <label class="custom-control-label" :for="item.id"></label>
                        </div>
                        </td>
                    </template>

                    <template #stt="{index}">
                        <td>{{$refs.mainTable.getTotalElementByPage + index }}</td>
                    </template>
                    
                    </BaseTable>
                </CCardBody>
                </CCard>
            </div>
            </template>

        <template v-slot:footer>
            <div slot="footer">

                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="isShowPopup = false"
                    ><i class="fa fa-reply"></i> Hủy bỏ
                </button>&nbsp;

                <button
                    type="button"
                    class="btn btn-primary"
                    @click="submitData()"
                    >
                    <i class="fa fa-plus"></i> Thêm
                </button
                >
            
            </div>
        </template>
        <BaseLoading :loading="loading.value"></BaseLoading>
    </CModal>
</template>
<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTable from "../base/BaseDataTable";

export default {
  props: ["actionTypeMapping"],
  components: {BaseInput, BaseSelect, BaseLoading, BaseTable},
  data() {
    var that = this;

    return {
      isShowPopup: false,
      actionTypeKey: '',
      actionData: {
        // actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          saleProgramId: that.$route.params.id,
          listProductSelected: []
        }
      },
      loading: {value: false},
      codeInput: {
        options: {
          placeholder: "Mã sản phẩm",
          label: 'Mã sản phẩm'
        },
        data: {
          name: "productCode",
          model: "",
          // updateTrigger: function () {
          //   return that.$refs.mainTable;
          // }
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên sản phẩm",
          label: 'Tên sản phẩm'
        },
        data: {
          name: "productName",
          model: "",
          // updateTrigger: function () {
          //   return that.$refs.mainTable;
          // }
        }
      },
      saleProgramId: {
        data: {
          name: "saleProgramId",
          model: that.$route.params.id,
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "true", value: "Hoạt động"}
          ],
          model: 'true',
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            {key: "stt", label: "STT"},
            {key: "code", label: "Mã sản phẩm"},
            {key: "name", label: "Tên sản phẩm"},
          ],
          slots: ["checkbox","stt"],
          pageSize: 20
        },
        dataSource: {
          url: "/product-sale-program/pageProductSelect",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data)
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
      
    };
    
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warning",
      title: "Warning"
    }
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listProductSelected = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listProductSelected.push(each.id);
        });
      } else {
        this.actionData.model.listProductSelected = [];
      }
    },
    submitData: function () {
      let that = this;
    
      if(that.actionData.model.listProductSelected.length == 0){
          that.showWarningMsg({message: 'Vui lòng chọn sản phẩm'});
      }

      var actionType = this.actionType;
      var _successCallback = actionType.successCallback;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/product-sale-program/createProductSaleProgram",
        dataSubmit: function () {
          return {'saleProgramId': that.actionData.model.saleProgramId, 
                    'lstProductId': that.actionData.model.listProductSelected};
        },
        successCallback: function (response) {
          that.isShowPopup = false;
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else if(_successCallback){
            _successCallback(response.data);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.isShowPopup = false;
        }
      });
    },
    setCurrAction: function(key) {
      this.actionTypeKey = key;
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  updated() {

  },
  computed: {
    actionType: function() {
      return this.actionTypeMapping.get(this.actionTypeKey);
    }
  },
  watch: {
   actionTypeKey: function(newValue) {
     if(newValue) {
       this.isShowPopup = true;
     }
   },
   isShowPopup: function(newValue) {
     if(!newValue) {
       this.actionTypeKey = null;
     }
   },
   "actionData.model.listProductSelected": function (newValue) {
      var that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  }
};
</script>
<style scoped></style>
